//state used everywhere
export * from './localState';

//export queries
export * from './queries';

//state used only on a specific stage
export * as DefineBatchDetailsState from './state.DefineBatchDetails';
export * as SelectPropertiesState from './state.SelectProperties';
